import { Component, Input } from '@angular/core';
import { IHeaderResponsivenessOptions } from 'app/shared/models/header-display-options';

@Component({
    selector: 'app-header-user-settings',
    templateUrl: './header-user-settings.component.html',
    styleUrls: ['./header-user-settings.component.scss'],
    standalone: false
})
export class HeaderUserSettingsComponent{
    @Input() headerResponsivenessOptions: IHeaderResponsivenessOptions;

    public isDevMode = /localhost/.test(document.location.host)

    
}